<h1 mat-dialog-title class="notification-title no-select">{{ heading }}</h1>
<div mat-dialog-content>
	@if (!isContentComponent()) {
		<p>{{ content }}</p>
	} @else {
		<ng-container *ngComponentOutlet="contentComponent; inputs: contentContext"></ng-container>
	}
</div>
<div mat-dialog-actions>
	@if (okButtonText) {
		<button mat-flat-button color="primary" (click)="onOkClick()">{{ okButtonText }}</button>
	}
	@if (cancelButtonText) {
		<button mat-flat-button color="primary" (click)="onCancelClick()" cdkFocusInitial>
			{{ cancelButtonText }}
		</button>
	}
</div>
